import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import moment from 'jalali-moment';
import { toast } from "react-toastify";

import { commafy, swal } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const SignalsCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('signals'), link: '/signals-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createSignal = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let status = parseInt(event.target.signalStatus.value);
		switch(signal.signal_state){
			case 0:
				if(![0, 1, 4].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
			case 1:
				if(![1, 6].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
			case 2:
				if(![2, 6].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
			case 3:
				if(![3].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
			case 4:
				if(![4].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
			case 5:
				if(![5].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
			case 6:
				if(![6].includes(status))
					return toast.warn(t('select_status_correctly'), 'warning');
				break;
		}
		let body = {
			signal_id: id,
			signal_state: status
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/signals/admin/' + ((componentType === 'edit') ? 'editState' : componentType), body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					setSignal({
						...signal,
						signal_state: status
					});
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	}
	
	const [signal, setSignal] = useState({});
	const getSignal = async () => {
		let body = {
			signal_id: id
		};
		let response = await _post('/signals/admin/getOne', body);
		switch(response.code){
			case 200:
				setSignal(response.data.signal);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const signalStatusList = [
		{ key: t('pending'), value: 0, disabled: ![0].includes(signal?.signal_state) },
		{ key: t('confirmed'), value: 1, disabled: ![0, 1].includes(signal?.signal_state) },
		{ key: t('active'), value: 2, disabled: ![2].includes(signal?.signal_state) },
		{ key: t('closed'), value: 3, disabled: ![3].includes(signal?.signal_state) },
		{ key: t('failed'), value: 4, disabled: ![0, 4].includes(signal?.signal_state) },
		{ key: t('canceled'), value: 5, disabled: ![5].includes(signal?.signal_state) },
		{ key: t('canceled_after_confirmation'), value: 6, disabled: ![1, 2, 6].includes(signal?.signal_state) }
	];

	useEffect(() => {
		if(componentType === 'edit')
			getSignal();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('signal')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createSignal}>
						<div className="row gx-2">
							<FormField fieldKey="signalCreationDate" title={t('creation_date')} value={signal?.create_date ? moment(signal?.create_date?.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD') : ''} disabled ltr />
							<FormField fieldKey="signalUser" title={t('user')} value={signal?.user_id_information?.user_fullname} disabled rtl />
							<FormField fieldKey="signalStock" title={t('stock')} value={signal?.stock_id_information?.stock_information?.stock_symbol} disabled rtl />
							<FormField fieldKey="signalStartPoint" title={t('start_point')} value={commafy(signal?.start_point)} disabled ltr />
							<FormField fieldKey="signalEndPoint" title={t('end_point')} value={commafy(signal?.profit_point)} disabled ltr />
							<FormField fieldKey="signalLossPoint" title={t('loss_point')} value={commafy(signal?.loss_point)} disabled ltr />
							<FormField fieldKey="signalPrice" title={t('price')} value={commafy(signal?.signal_price)} disabled ltr />
							<FormField type="select" fieldKey="signalStatus" title={t('status')} value={signal?.signal_state} required selectItems={signalStatusList} />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('update')}
								</LoadingButton>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default SignalsCreate;
